<ng-container *ngIf="viewModel()">
    <bs-linear-module-container [expandable]="isModuleCollapsible" [trackingBetslipTypeContext]="betslipType">
        <ng-template [bsLinearModuleHeader]>
            <div class="single-bet-linear__title-summary-container">
                <div class="single-bet-linear__title">
                    <span>{{ selectedPicksTitle(viewModel().pickCount) }}</span>
                    <span class="single-bet-linear__stake-all-info" *ngIf="showGeneralStakeInHeader(viewModel().pickCount)">{{
                        sitecore.betslip.linear.StakeAllSelections
                    }}</span>
                </div>
                <ng-container *ngIf="showGeneralStakeInHeader(viewModel().pickCount)">
                    <bs-linear-single-bet-general-stake class="single-bet-linear__summary"></bs-linear-single-bet-general-stake>
                </ng-container>
            </div>
        </ng-template>

        <ng-template [bsLinearModuleContent]>
            <ng-container *ngIf="showGeneralStakeInBody(viewModel().pickCount)">
                <bs-linear-single-bet-general-stake-container [picksCount]="viewModel().pickCount"></bs-linear-single-bet-general-stake-container>
            </ng-container>
            <bs-digital-pick-list class="single-bet-linear__pick_list">
                <bs-digital-single-bet-pick
                    *ngFor="let pick of viewModel().pickList; trackBy: pickTrackBy"
                    [pick]="pick"
                    [singleBetPick]="singleBetPick(viewModel().singleBetState, pick)"
                    [isMultiSingleBet]="isMultiSingleBet()"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [removeButtonPosition]="removeButtonPosition"
                    [removeButtonStyle]="removeButtonStyle"
                    [alwaysShowStakeInput]="alwaysShowStakeInput"
                    [msAutomation]="pick.id.toString()"
                    [isLinear]="true">
                </bs-digital-single-bet-pick>
            </bs-digital-pick-list>
        </ng-template>
    </bs-linear-module-container>
</ng-container>
